const timelineItem = {
  id: null,
  date: null,
  title: null,
  note: null,
  attachments: [],
  canUpload: false,
  canReject: false,
  canRemoveFile: false,
  nextStep: false
}

const permissions = {
  WORKFLOW_MANAGER: 'workflow.manager',
  WORKFLOW_INTERNAL_MANAGER: 'workflow.internal_manager',
  WORKFLOW_CONTROLLER: 'workflow.controller',
  PROJECT_CONTROL_MANAGER: 'project_control.manager',
  SURVEY_MANAGER: 'survey.manager',
  ANNOUNCEMENT_MANAGER: 'announcement.manager',
  DOCFLOW_MANAGER: 'docflow.manager',
  DOCFLOW_CONTROLLER: 'docflow.controller',
  DOCFLOW_SUPERVISOR: 'docflow.supervisor',
  DOCFLOW_APPROVER: 'docflow.can_approve_document',
  DOCFLOW_MODERATOR: 'docflow.moderator',
  DOCFLOW_APPEAL_MANAGER: 'docflow.appeal_manager',
  DOCFLOW_OUTGOING_MANAGER: 'docflow.outgoing_manager',
  DOCFLOW_ASSISTANT: 'docflow.assistant',
  DOCFLOW_HEAD: 'docflow.head',
  DOCFLOW_EXECUTIVE_OFFICER: 'docflow.executive_officer',
  SUPER_USER: 'docflow.super_user',
  REPORTS_MANAGER: 'docflow.reports_manager',
  DOCFLOW_PLAN_CREATOR: 'docflow.plan_creator',
}

const docflowRoutes = {
  incoming: 'docflowIncomingDetail',
  outgoing: 'docflowOutgoingDetail',
  appeal: 'docflowAppealDetail'
}

export {
  timelineItem,
  permissions,
  docflowRoutes
}
